// Utility: convert country name -> emoji flag using regional indicator symbols.
// We map common country names to ISO-2 codes, then convert to flag emoji.

const NAME_TO_ISO = {
  'Australia': 'AU', 'United States': 'US', 'United States of America': 'US',
  'United Kingdom': 'GB', 'Great Britain': 'GB', 'England': 'GB',
  'Canada': 'CA', 'New Zealand': 'NZ', 'Ireland': 'IE',
  'India': 'IN', 'Pakistan': 'PK', 'Bangladesh': 'BD', 'Sri Lanka': 'LK', 'Nepal': 'NP',
  'China': 'CN', 'Japan': 'JP', 'South Korea': 'KR', 'North Korea': 'KP',
  'Vietnam': 'VN', 'Thailand': 'TH', 'Indonesia': 'ID', 'Philippines': 'PH',
  'Malaysia': 'MY', 'Singapore': 'SG', 'Hong Kong': 'HK', 'Taiwan': 'TW',
  'Germany': 'DE', 'France': 'FR', 'Italy': 'IT', 'Spain': 'ES', 'Portugal': 'PT',
  'Netherlands': 'NL', 'Belgium': 'BE', 'Switzerland': 'CH', 'Austria': 'AT',
  'Sweden': 'SE', 'Norway': 'NO', 'Denmark': 'DK', 'Finland': 'FI', 'Iceland': 'IS',
  'Poland': 'PL', 'Czech Republic': 'CZ', 'Czechia': 'CZ', 'Slovakia': 'SK',
  'Hungary': 'HU', 'Romania': 'RO', 'Bulgaria': 'BG', 'Greece': 'GR',
  'Russia': 'RU', 'Ukraine': 'UA', 'Belarus': 'BY', 'Moldova': 'MD',
  'Turkey': 'TR', 'Israel': 'IL', 'Saudi Arabia': 'SA', 'United Arab Emirates': 'AE',
  'Qatar': 'QA', 'Kuwait': 'KW', 'Oman': 'OM', 'Bahrain': 'BH',
  'Iran': 'IR', 'Iraq': 'IQ', 'Syria': 'SY', 'Lebanon': 'LB', 'Jordan': 'JO',
  'Egypt': 'EG', 'Morocco': 'MA', 'Algeria': 'DZ', 'Tunisia': 'TN', 'Libya': 'LY',
  'South Africa': 'ZA', 'Nigeria': 'NG', 'Kenya': 'KE', 'Ethiopia': 'ET',
  'Ghana': 'GH', 'Tanzania': 'TZ', 'Uganda': 'UG', 'Zimbabwe': 'ZW',
  'Brazil': 'BR', 'Argentina': 'AR', 'Chile': 'CL', 'Peru': 'PE', 'Colombia': 'CO',
  'Venezuela': 'VE', 'Ecuador': 'EC', 'Bolivia': 'BO', 'Uruguay': 'UY', 'Paraguay': 'PY',
  'Mexico': 'MX', 'Cuba': 'CU', 'Jamaica': 'JM', 'Dominican Republic': 'DO',
  'Puerto Rico': 'PR', 'Haiti': 'HT', 'Costa Rica': 'CR', 'Panama': 'PA',
};

export function countryToFlag(name) {
  if (!name) return '🌐';
  const iso = NAME_TO_ISO[name];
  if (!iso) return '🌐';
  const codePoints = iso
    .toUpperCase()
    .split('')
    .map((c) => 127397 + c.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}
